export default "__VITE_ASSET__DELLI_Pu__"